import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=67bb4b32&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=67bb4b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb4b32",
  null
  
)

export default component.exports